import React, { useEffect, useRef } from 'react';
import { Map, GoogleApiWrapper } from 'google-maps-react';
import Axios from '../../Axios';

import signals from '../../Data/signals.json'
import { useState } from 'react';
import CustomOverlayView from './Overlay';

const mapStyles = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0
};

const darkMapStyle = [
  { elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#757575' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#181818' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'poi.park', elementType: 'labels.text.stroke', stylers: [{ color: '#1b1b1b' }] },
  { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#2c2c2c' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
  { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#373737' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3c3c3c' }] },
  { featureType: 'road.highway.controlled_access', elementType: 'geometry', stylers: [{ color: '#4e4e4e' }] },
  { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#2f2f2f' }] },
  { featureType: 'transit.station', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#000000' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#3d3d3d' }] }
];

const getSignalIconUrl = (signal) => {
  switch (signal) {
    case 'Prohibido estacionar':
      return 'https://storage.googleapis.com/vipa-microservices.appspot.com/web/signals/no-estacionar.png'; 
    case 'Parterre central':
      return 'https://storage.googleapis.com/vipa-microservices.appspot.com/web/signals/parterre.png'; 
    case 'SOLO MOTOS':
      return 'https://storage.googleapis.com/vipa-microservices.appspot.com/web/signals/solo-motos.png'; 
    default:
      return 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
  }
};

function HeatmapComponent({ google, filter }) {
  const mapRef = useRef(null);
  const heatmapRef = useRef(null);
  const signalMarkersRef = useRef([]);

  const [overlayVisible, setOverlayVisible] = useState(false);
const [overlayPosition, setOverlayPosition] = useState(null);
const [overlayContent, setOverlayContent] = useState('');

  const addSignalMarkers = () => {
    // Limpiar marcadores anteriores
    signalMarkersRef.current.forEach(marker => marker.setMap(null));
    signalMarkersRef.current = [];

    signals.forEach(({ latlong, signal, address }) => {
      const [lat, lng] = latlong.split(',').map(Number);

      const marker = new google.maps.Marker({
        position: { lat, lng },
        map: mapRef.current,
        title: signal,
        icon: {
         url: getSignalIconUrl(signal),
         scaledSize: new google.maps.Size(32, 32) 
        }
      });

   marker.addListener('click', () => {
  setOverlayContent(`
    <div style="
      background: white;
      border-radius: 8px;
      padding: 10px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      max-width: 220px;
      font-family: Arial, sans-serif;
    ">
      <div style="color: black;font-weight:bold; font-size: 14px;">${address}</div>
      <div style="color: black;margin-bottom: 6px; font-size: 13px;">${signal}</div>
      <button class="close-overlay" style="
        background: #ff4d4f;
        color: white;
        border: none;
        padding: 4px 8px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
      ">Cerrar</button>
    </div>
  `);
  setOverlayPosition(new google.maps.LatLng(lat, lng));
  setOverlayVisible(true);
});

      signalMarkersRef.current.push(marker);
    });
  };

  const fetchHeatmapData = (bounds, filter) => {
    if (!bounds) return;

    const params = {
      min_lat: bounds.getSouthWest().lat(),
      max_lat: bounds.getNorthEast().lat(),
      min_lng: bounds.getSouthWest().lng(),
      max_lng: bounds.getNorthEast().lng(),
      ...filter
    };

    Axios.get('/analytics/heatmap', { params })
      .then(response => {
        const points = response.data.map(
          item => new google.maps.LatLng(item.lat, item.lng)
        );

        if (!heatmapRef.current) {
          heatmapRef.current = new google.maps.visualization.HeatmapLayer({
            data: points,
            map: mapRef.current,
            radius: 20,  
            gradient: [
              "rgba(0, 255, 255, 0)",
              "rgba(0, 255, 255, 1)",
              "rgba(0, 191, 255, 1)",
              "rgba(0, 127, 255, 1)",
              "rgba(0, 63, 255, 1)",
              "rgba(0, 0, 255, 1)",
              "rgba(0, 0, 223, 1)",
              "rgba(0, 0, 191, 1)",
              "rgba(0, 0, 159, 1)",
              "rgba(0, 0, 127, 1)",
              "rgba(63, 0, 91, 1)",
              "rgba(127, 0, 63, 1)",
              "rgba(191, 0, 31, 1)",
              "rgba(255, 0, 0, 1)"
            ]
          });
        } else {
          heatmapRef.current.setData(points);
        }
      })
      .catch(error => {
        console.error('Error cargando heatmap:', error);
      });
  };

  const handleMapReady = (_mapProps, map) => {
    mapRef.current = map;
    map.setOptions({ styles: darkMapStyle });

    fetchHeatmapData(map.getBounds());
    addSignalMarkers();

    map.addListener('idle', () => {
      fetchHeatmapData(map.getBounds(), filter);
    });
  };

  useEffect(() => {
    if (!mapRef.current) return;
    fetchHeatmapData(mapRef.current.getBounds(), filter);
  }, [filter]);

  return (<>
    <Map
      google={google}
      zoom={13}
      style={mapStyles}
      initialCenter={{ lat: -2.191745, lng: -79.894690 }}
      onReady={handleMapReady}
    />
  {overlayVisible && overlayPosition && (
  <CustomOverlayView
    google={google}
    map={mapRef.current}
    position={overlayPosition}
    content={overlayContent}
    onClose={() => setOverlayVisible(false)}
  />
)}</>
  
  );
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['visualization']
})(HeatmapComponent);
